import { LocalizedItem } from "./domain/api/addons/LocalizedItem";

const agent =  window.navigator.userAgent;

export enum DeviceType {
    Desktop = "Desktop",
    Mobile = "Mobile",
    Tablet = "Tablet",
}

export enum Browser {
    IE = "MSIE",
    CHROME = "Chrome",
    FIREFOX = "Firefox",
    SAFARI = "Safari",
    EDGE = "Edge",
    ANHEIM = "Anheim",
    OPERA = "Opera",
    UNKNOWN = "Unknown",
}

export const isPictureInPictureSupported = () => {
    
    if (getBrowserName() === Browser.SAFARI) {
        // safari seems no to have PIP for live media streams
        return false;
    }

    if (!('pictureInPictureEnabled' in document)) {
        return false;
    }
    else if (!(document as any).pictureInPictureEnabled) {
        return false
    }

    return true;
}

export const getMeetOutSyncContext = () => {
    return sessionStorage.getItem("meet-out-code");
}

export const getBrowserName = () => {
    if (agent.indexOf("Chrome") > -1 && agent.indexOf("Edg") === -1) {
        return Browser.CHROME;
    }

    if (agent.indexOf("Edge") > -1) {
        return Browser.EDGE;
    }

    if (agent.indexOf("Edg") > -1) {
        return Browser.ANHEIM;
    }

    if (agent.indexOf("Safari") > -1) {
        return Browser.SAFARI;
    }

    if (agent.indexOf(Browser.FIREFOX) > -1) {
        return Browser.FIREFOX;
    }

    if (agent.indexOf("OPR") > -1) {
        return Browser.OPERA;
    }

    if (agent.indexOf("Trident") > -1) {
        return Browser.IE;
    }

    return "Unknown";
};

export const getDeviceType = () => {

    // tslint:disable-next-line:max-line-length
    const mobile = /(android|ipod|\w*?mobile\w*?|\w*?phone\w*?)/i;
    const tablet = /tablet|ipad/i;

    if (window.navigator.userAgent.match(mobile)) {
        return DeviceType.Mobile;
    }
    
    if (window.navigator.userAgent.match(tablet)) {
        return DeviceType.Tablet;
    }
    
    return DeviceType.Desktop;
};

export const getLocalizedText = (localizedItem: LocalizedItem, culture: string) => {
    
    const locale = normalizeLocale(culture);

    let text = localizedItem.localized[locale];
    if (!text) {
        text = localizedItem.localized["en"];
    }

    return text;
}


export const normalizeLocale = (locale: string) : string => {
    if (!locale)
    {
        return "en";
    }

    if ( locale.toLowerCase().startsWith("en"))
    {
        return "en";
    }
    
    if (locale.toLowerCase().startsWith("es"))
    {
        return "es";
    }

    if (locale.toLowerCase().startsWith("de"))
    {
        return "de";
    }

    if (locale.toLowerCase().startsWith("fr"))
    {
        return "fr";
    }

    if (locale.toLowerCase().startsWith("it"))
    {
        return "it";
    }
    
    if (locale.toLowerCase().startsWith("pl"))
    {
        return "pl";
    }

    if (locale.toLowerCase().startsWith("sr-latn"))
    {
        return "sr-Latn";
    }

    if (locale.toLowerCase().startsWith("sr-cyrl"))
    {
        return "sr-Cyrl";
    }

    if (locale.toLowerCase().startsWith("sr"))
    {
        return "sr-Latn";
    }


    return "en";
}

export interface MeetOutSyncContext {
    meetCode: string;
    tenantId: string;
    timestamp: number;
}

export const isTeamsAddonMode = (window.location.ancestorOrigins && window.location.ancestorOrigins.contains("https://teams.microsoft.com")) ||
                                (getBrowserName() === Browser.FIREFOX && !!getMeetOutSyncContext())
